import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<div class="fps svelte-1agysd0nt3gb6"> </div>`);

export default function FpsMeter($$anchor, $$props) {
	$.push($$props, true);

	// Debug-only overlay (hash contains debug=1). Own rAF loop with a
	// 60-sample ring; display updates twice per second.
	let fps = $.state(0);

	let ms = $.state(0);

	$.user_effect(() => {
		const samples = [];
		let prev = performance.now();
		let lastUpdate = prev;
		let raf = 0;

		const loop = (now) => {
			const dt = now - prev;

			prev = now;
			samples.push(dt);

			if (samples.length > 60) samples.shift();

			if (now - lastUpdate >= 500 && samples.length) {
				lastUpdate = now;

				const avg = samples.reduce((a, b) => a + b, 0) / samples.length;

				$.set(ms, avg);
				$.set(fps, avg > 0 ? 1000 / avg : 0, true);
			}

			raf = requestAnimationFrame(loop);
		};

		raf = requestAnimationFrame(loop);

		return () => cancelAnimationFrame(raf);
	});

	var div = root();
	var text = $.child(div);

	$.reset(div);
	$.template_effect(($0, $1) => $.set_text(text, `${$0 ?? ''} fps · ${$1 ?? ''} ms`), [() => $.get(fps).toFixed(0), () => $.get(ms).toFixed(1)]);
	$.append($$anchor, div);
	$.pop();
}
import "bun-svelte:FpsMeter.svelte-29fg11q7b3f9m-style.css";